import React from "react";

export const EnergyLabel = ({ label }) => {
  if (!label) return null;

  const labelColors = {
    A: "bg-emerald-500",
    B: "bg-green-500", 
    C: "bg-lime-500",
    D: "bg-yellow-500",
    E: "bg-orange-500",
    F: "bg-red-500",
    G: "bg-red-600",
  };

  const color = labelColors[label] || "bg-slate-400";

  return (
    <div className={`absolute top-3 right-3 ${color} text-white text-xs font-bold px-2 py-1 rounded-lg shadow-lg backdrop-blur-sm`}>
      {label}
    </div>
  );
};